import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './catalog-navbar.component'

let module = angular.module('catalogNavbar', [
  uiRouter
])

.component('catalogNavbar', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/catalog-navbar/index.js